import Navbar from "../components/lib/Navbar";
import HeroSection from "../components/landing-page/about/HeroSection";
import Objectives from "../components/landing-page/about/Objectives";
import Team from "../components/landing-page/about/Team";
import JobAdd from "../components/landing-page/about/Job";
import Footer from "../components/lib/Footer";
import Loader from "../components/lib/Loader";

const About = () => {
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <Navbar />
      </div>
      <div>
        <HeroSection />
      </div>
      <div>
        <Objectives />
      </div>
      <div>
        <Team />
      </div>
      <div>
        <JobAdd />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default About;
